import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import Icon from 'components/icon/icon'

import AlertBanner from 'components/alerts/alert-banner'
import Loader from 'components/loader/loader'

import { 
	doSort,
	getBaseSlugFromPath,
	formatByTimeZone,
	formatStandardDateTime,
	getPrimaryColumnValue,
	getStatusName
} from 'utils'

import {
	getCurrentUser
} from 'state/selectors'

class ActiveProjects extends Component {
	state = {
		activeProjectId: null,
		listMaxHeight: 450,
		sortBy: 'name',
		isReversed: false
	}

	projectsList = []
	listRefs = {}

	componentWillMount = _ => {
		this.getProjectsList()
	}

	componentDidMount = _ => {
		this.setDefaultActiveProject()
	}

	componentWillUpdate = (nextProps, nextState) => {
		this.getProjectsList(nextProps)
		this.setDefaultActiveProject(nextState)
	}

	setDefaultActiveProject = (state = this.state) => {
		if(!state.activeProjectId && this.projectsList.length){
			this.setState({
				activeProjectId: this.projectsList[0].project.id
			})
		}
	}

	handleSelectProject = project => {
		this.setState({
			activeProjectId: project.id
		})
	}

	getProjectsList = (props = this.props) => {
		const projects = []

		const {
			user,
			allTasks,
			allMilestones,
			allProjects
		} = props

		user.tasks && user.tasks.forEach(taskId => {
			const task = allTasks[taskId]

			if(!task){
				return
			}

			const milestone = allMilestones[task.milestone_id]

			if(!milestone){
				return
			}

			const project = allProjects[milestone.project_id]

			if(!project){
				return
			}

			const projectIndexIfExists = projects.findIndex(loopedProject => {
				return loopedProject.project && loopedProject.project.id === project.id
			})

			if(projectIndexIfExists === -1){
				projects.push({
					project,
					tasks: [task]
				})
			}else{
				projects[projectIndexIfExists].tasks.push(task)
			}
		})

		this.projectsList = projects
	}

	getListHeight = _ => {
		let listHeight = 470

		if(this.listRefs.outer && this.listRefs.inner){
			const outerHeight = this.listRefs.outer.getBoundingClientRect().height
			const offsetTop = this.listRefs.inner.offsetTop + 30
			const headingHeight = this.listRefs.heading.getBoundingClientRect().height

			listHeight = outerHeight - offsetTop - headingHeight + 5
		}

		return listHeight
	}

	getStatusInfo = (task, project) => {
		const {
			allStatuses
		} = this.props

		const statusId = getPrimaryColumnValue('status', task, project)

		if(statusId){
			const statusName = getStatusName(statusId, project, allStatuses)

			return (
				<span>
					<em className={'colour-id-'+statusId} />
					{ statusName }
				</span>
			)
		}else{
			return null
		}
	}

	getLastOpenedText = activeProject => {
		const {
			user
		} = this.props

		const project = activeProject.project

		if(user.project_last_opened && user.project_last_opened[project.id]){
			const rawDate = user.project_last_opened[project.id]

			const timeZonedDateString = formatStandardDateTime(formatByTimeZone(rawDate, null, true), null, false, ' •', true)

			return `Last opened ${ timeZonedDateString }`
		}else{
			return 'Never been opened'
		}
	}

	setSorting = type => {
		this.setState({
			sortBy: type,
			isReversed: (this.state.sortBy == type) ? !this.state.isReversed : false
		})
	}

	render() {
		const {
			allMilestones,
			match,
			user,
			loading
		} = this.props

		const {
			activeProjectId,
			sortBy,
			isReversed
		} = this.state

		const activeProject = this.projectsList.find(project => {
			return project.project.id === activeProjectId
		})

		let taskList = activeProject ? [...activeProject.tasks] : []

		let sortType = null
		let sortKey = null
		let columnId = null

		let datesColumn = null

		switch(sortBy){
			case 'name':
				sortType = 'alpha'
				sortKey = 'name'
				break
			case 'status':
				sortType = 'number'
				sortKey = 'status_id'

				const statusColumn = getPrimaryColumnValue('status', null, activeProject.project, null, true)

				if(statusColumn){
					columnId = statusColumn.id
				}

				break
			case 'startDate':
				sortType = 'date'
				sortKey = 'start'

				datesColumn = getPrimaryColumnValue('date', null, activeProject.project, null, true)

				if(datesColumn){
					columnId = datesColumn.id
				}
				break
			case 'date':
				sortType = 'date'
				sortKey = 'end'

				datesColumn = getPrimaryColumnValue('date', null, activeProject.project, null, true)

				if(datesColumn){
					columnId = datesColumn.id
				}
		}

		taskList = doSort(taskList, sortType, sortKey, isReversed, columnId)

		let containerClassName = 'active-projects'

		if(this.projectsList.length){
			containerClassName += ' no-padding'
		}

		return (
			<div className={containerClassName}>
				<Loader visible={loading && !this.projectsList.length} />
				{ (!this.projectsList.length && !loading) ? 
					<AlertBanner
						title={`${user.first_name} has no active projects!`} 
						body={`This'll show their upcoming tasks sorted by project, when they've got some.`}
					/>
					:
					<div>
						{ this.projectsList.length ?
							<ul className="active-projects-list">
								{ this.projectsList.map(project => {
									return (
										<li 
											key={project.project.id}
											className={activeProjectId == project.project.id ? 'active' : null}
										>
											<button
												onClick={_ => {this.handleSelectProject(project.project)}}
											>
												{ project.project.name }
											</button>
										</li>
									)
								})}
							</ul>
						: null }
						<div 
							className="active-projects-main"
							ref={ref => this.listRefs.outer = ref}
						>
							{ activeProject &&
								<div>
									<h2>
										{ activeProject.project.name}
									</h2>
									<span className="disclaimer">
										{ this.getLastOpenedText(activeProject) }
									</span>
									<div 
										className="active-projects-task-list"
										ref={ref => this.listRefs.inner = ref}
									>
										<div 
											className={isReversed ? 'top inverted' : "top"}
											ref={ref => this.listRefs.heading = ref}
										>
											<label 
												className={(sortBy == 'name' ? 'active' : null)}
												onClick={_ => {this.setSorting('name')}}
											>
												Tasks
												<Icon name="caret-down" />
											</label>
											<label 
												className={(sortBy == 'status' ? 'active' : null)}
												onClick={_ => {this.setSorting('status')}}
											>
												Status
												<Icon name="caret-down" />
											</label>
											<label 
												className={(sortBy == 'startDate' ? 'active' : null)}
												onClick={_ => {this.setSorting('startDate')}}
											>
												Start date
												<Icon name="caret-down" />
											</label>
											<label 
												className={(sortBy == 'date' ? 'active' : null)}
												onClick={_ => {this.setSorting('date')}}
											>
												Due date
												<Icon name="caret-down" />
											</label>
										</div>
										<ul 
											className="bottom headertab-list"
										>
											{ taskList.map(task => {
												const taskDates = getPrimaryColumnValue('date', task, activeProject.project)

												const formattedStartDate = (taskDates && taskDates.start) ? moment(taskDates.start).format('D MMM') : null
												const formattedEndDate = (taskDates && taskDates.end) ? moment(taskDates.end).format('D MMM') : null

												const url = `${getBaseSlugFromPath(match.url)}/projects/${activeProject.project.slug}/tasks/${task.id}`

												return (
													<li key={task.id}>
														<Link to={url}>
															<span className="task-name">
																{ task.name }
																<span className="disclaimer">
																	{ allMilestones[task.milestone_id].name }
																</span>
															</span>
															<span className="task-status">
																{ this.getStatusInfo(task, activeProject.project) }
															</span>
															<span className={formattedStartDate ? "task-date" : "task-date empty"}>
																{ formattedStartDate ? formattedStartDate : '(None)' }
															</span>
															<span className={formattedEndDate ? "task-date" : "task-date empty"}>
																{ formattedEndDate ? formattedEndDate : '(None)' }
															</span>
														</Link>
													</li>
												)
											})}
										</ul>
									</div>
								</div>
							}
						</div>
					</div>
				}
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		allTasks: state.account.entities.tasks,
		allMilestones: state.account.entities.milestones,
		allProjects: state.account.entities.projects,
		allStatuses: state.account.entities.statuses,
		userData: getCurrentUser(state)
	}
}

export default withRouter(connect(mapStateToProps, {
	
})(ActiveProjects))


// WEBPACK FOOTER //
// ./src/components/active-projects/active-projects.jsx